export { default } from './TimelineSeparator';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/TimelineSeparator/index.js
// module id = 388
// module chunks = 0